export const ProgressBar = ({ current, total }) => {
  const pct = Math.round(((current + 1) / total) * 100);
  return (
    <div className="mb-8" data-testid="survey-progress">
      <div className="flex justify-between text-sm text-[#7A6B63] mb-2">
        <span data-testid="survey-progress-label">Sezione {current + 1} di {total}</span>
        <span>{pct}%</span>
      </div>
      <div className="h-2.5 rounded-full bg-[#EAE0D0] overflow-hidden shadow-inner">
        <div className="h-full bg-gradient-to-r from-[#C85A32] to-[#D99B26] transition-all duration-500 ease-out" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};
